<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <!-- <h1 class="mb-2">classes</h1>
            <p>Hello, welcome to Ulum Al-Azhar Portal</p> -->

            <salary-table :classes="salaryReport.classes" :salary-report="salaryReport" :loading="loading" title="Previous Salary Report" />
        </v-container>
        
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import SalaryTable from './salary-table'

export default {
    name: "previous-salary",
    components: {
        SalaryTable
    },
    data(){
        return {
            searchQuery: '',
            loading: false,
        }
    },
    computed: {
        salaryReport(){
            return this.$store.state.historyModule.previousSalaryClasses;
        },
        visibleclasses(){
            const query = this.searchQuery.toLowerCase();
            let classes = this.salaryReport.classes;

            if (query){
                return classes.filter(salaryClass=>salaryClass.name.toLowerCase().search(query) !== -1)
            }

            return classes;
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadPreviousSalaryClasses').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        ...GlobalMethods
    },
    mounted(){
        if (!this.salaryReport.classes || this.salaryReport.classes.length === 0){
            this.loadData();
        }
    }
};
</script>
